
import React      from 'react';
import CSSModules from 'react-css-modules';

import style from './style.scss';

class ColumnContainer extends React.Component {

    render() {

        return (
            <div styleName="column-container">

                { this.props.children }

            </div>
        );
    }
}

export default CSSModules(ColumnContainer, style);


// WEBPACK FOOTER //
// ./components/ColumnContainer/index.js